export default __webpack_public_path__ + "static/con-8dd1781910202627fb268efce3b94510.jpg";